module.exports = __webpack_public_path__ + "static/media/start-buying-info.354827ae.webp";